module.exports = __webpack_public_path__ + "static/media/mountain.8a96672a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mountain.png
// module id = 1578
// module chunks = 0